export const vuetifyOptions = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#ff4600',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#D40000',
        info: '#4990e2',
        success: '#00AD07',
        warning: '#F0D800',
        white: '#FFFFFF',
      }
    }
  }
}